import { PaginationState } from "@tanstack/react-table"
import { Dispatch, SetStateAction } from "react"

import { AdminResponses } from "@tfg/types/endpoints/admin"

import { useCustomReactTable } from "~/components/hooks/useCustomReactTable"
import { CustomTable } from "~/components/table/CustomTable"
import { FindStandardsWithCertificateTypesResponseDto } from "~/gen/api"
import { useColumns } from "~/pages/Admin/MasterLists/CertificatesTypes/Standards/columns"

interface Props {
  standards: FindStandardsWithCertificateTypesResponseDto["data"]
  total: number
  certificatesTypesList: AdminResponses.CertificateTypeList[]
  pagination: PaginationState
  setPagination: Dispatch<SetStateAction<PaginationState>>
}

export const StandardsTable = ({
  standards,
  total,
  certificatesTypesList,
  pagination,
  setPagination,
}: Props) => {
  const columns = useColumns(certificatesTypesList ?? [], pagination)

  const table = useCustomReactTable({
    data: standards,
    columns,
    state: {
      pagination,
    },
    pageCount: Math.ceil(total / pagination.pageSize),
    manualPagination: true,
    onPaginationChange: setPagination,
  })

  return <CustomTable table={table} manualPaginationCount={total} />
}
